import { teamData } from "../mock/Team";

const Team = () => {
  return (
    <section className="bg-light py-5">
      <div className="container">
        <div className="row">
          <div className="col-12">
            <h2 className="text-center">Our Team Members</h2>
            <div className="text-center pt-3">
              <p className="" style={{ maxWidth: "60%", margin: "0 auto" }}>
                Warraich Traders was founded with the idea that nothing delivers
                superior quality and craftsmanship better then a solid team
                effort. Our exceptional team is comprised of some of the most
                experienced professionals in the industry.
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-5">
          {teamData.map((item) => (
            <div className="col-md-3 our_team_img" key={item.id}>
              <img src={item.imgSrc} alt="teamMember" className="rounded" />
              <h4 className="text-center mt-3">{item.name}</h4>
              <p className="text-center">{item.post}</p>
              <p className="text-center">
                <strong>Ph#</strong> {item.phone}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Team;
